/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import customerApi from '../../apis/api/customer';
import userApi from '../../apis/api/user';
import * as yup from 'yup';

const CustomerCreate = (props) => {
  const { notify } = props;
  const [agent, setAgent] = useState();
  const [firstname, setFirstname] = useState();
  const [surname, setSurname] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [note, setNote] = useState();
  const [error, setError] = useState();
  const [users, setUsers] = useState([]);
  const history = useHistory();

  useEffect(() => {
    getListUser();
  }, []);

  const getListUser = async () => {
    const res = await userApi.getUserList();
    setUsers(res?.data || []);
  };

  const validattionSchema = yup.object().shape({
    agent: yup.array().of(yup.string()),
    firstname: yup.string().required(),
    surname: yup.string().required(),
    email: yup.string().email(),
    mobile: yup.string().notRequired(),
    note: yup.string().notRequired(),
  });

  const handleCreateCustomer = async () => {
    try {
      const data = {
        agents: [agent],
        firstname: firstname,
        surname: surname,
        email: email,
        mobile: mobile,
        note: note,
        password: 'abcd1234',
      };

      const result = await validattionSchema.validate(data);
      const res = await customerApi.createCustomer(data);
      notify('Create customer successfully!');
      history.push('/dashboard/customers');
    } catch (err) {
      setError(err);
    }
  };

  return (
    <div className="card wrap-customer-create">
      <div className="card-header d-flex">
        <h6 className="title">CREATE CUSTOMERS</h6>
      </div>
      <div className="card-body">
        <form className="wrap-customer-create">
          <div className="mb-3">
            <label htmlFor="agent" className="form-label">
              Agent
            </label>
            <select
              onChange={(e) => setAgent(e.target.value)}
              className="form-select"
              name="agent"
              id="agent"
            >
              <option value="0">Choose Agent</option>
              {users.map((user, index) => (
                <option key={index} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label htmlFor="first-name" className="form-label">
              First Name
            </label>
            <input
              onChange={(e) => setFirstname(e.target.value)}
              type="text"
              className="form-control"
              id="first-name"
              aria-describedby="first-name-help"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="surname" className="form-label">
              Surname
            </label>
            <input
              onChange={(e) => setSurname(e.target.value)}
              type="text"
              className="form-control"
              id="surname"
              aria-describedby="surname-help"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              className="form-control"
              id="email"
              aria-describedby="email-help"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">
              Phone
            </label>
            <input
              onChange={(e) => setMobile(e.target.value)}
              type="text"
              className="form-control"
              id="phone"
              aria-describedby="phone-help"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="note" className="form-label">
              Note
            </label>
            <textarea
              onChange={(e) => setNote(e.target.value)}
              className="form-control"
              name="note"
              id="note"
              cols="30"
              rows="5"
            />
          </div>
          <div className="mb-3">
            <small id="user-type-help" className="form-text text-danger">
              {error?.message}
            </small>
          </div>
          <div className="mb-3">
            <Link to={`/dashboard/customers`} className="btn bt-light m-0">
              Cancel
            </Link>
            <Link to="#" onClick={() => handleCreateCustomer()} className="btn btn-primary">
              Save
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerCreate;
